/// <reference path="jquery.min.js" />
/// <reference path="jRespond.js" />
/// <reference path="jquery.inview.js" />
/// <reference path="owl.carousel.js" />
/// <reference path="jquery.validate.js" />
/// <reference path="formular.js" />
/************************************************* General functions STARTS *************************************************/
// HTML entities helper functions
function htmlEncode(value) {
    'use strict';

    //create a in-memory div, set it's inner text (which jQuery automatically encodes) then grab the encoded contents back out. The div never exists on the page.
    return $('<div/>').text(value).html();
}

function htmlDecode(value) {
    'use strict';

    return $('<div/>').html(value).text();
}

function isInArray(value, array) {
    return array.indexOf(value) > -1;
}

// Overlay closing function
function closeOverlay(type) {
    'use strict';

    var clicktarget = $(type.target);

    if (clicktarget.closest('#overlay-content').length === 0 || clicktarget.attr('id') === 'overlay-close') {
        $(document).off('click', 'body, #overlay-close', closeOverlay);
        $('body').removeClass('overflow-hidden');
        $('#overlay-container, #blur-container').remove();

        return false;
    }
}

function jump(select_element, target_frame){
	eval(target_frame+".location='"+select_element.options[select_element.selectedIndex].value+"'");
} 

// 04.04.2016
function mailToDecrypt(s){
	var n = 0;
	var r = "";
	for( var i = 0; i < s.length; i++){
		n = s.charCodeAt( i );
		if( n >= 8364 ){
			n = 128;
		}
		r += String.fromCharCode( n - 1 );
	}
	return r;
}

// 04.04.2016
function mailDecryptLink(s){
	location.href = mailToDecrypt(s);
}

/**
 * Gets the browser name or returns an empty string if unknown. 
 * This function also caches the result to provide for any 
 * future calls this function has.
 *
 * @returns {string}
 */
var browser = function() {
    // Return cached result if avalible, else get result then cache it.
    if (browser.prototype._cachedResult)
        return browser.prototype._cachedResult;

    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    var isChrome = !!window.chrome && !!window.chrome.webstore;

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    return browser.prototype._cachedResult =
        isOpera ? 'Opera' :
        isFirefox ? 'Firefox' :
        isSafari ? 'Safari' :
        isChrome ? 'Chrome' :
        isIE ? 'IE' :
        isEdge ? 'Edge' :
        isBlink ? 'Blink' :
        "Don't know";
};


// Animate function
$.fn.animateElement = function(options) {
    'use strict';

    var element = this,
        animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

    var settings = $.extend({
        animtype: element.attr('data-anim'),
        animinitial: element.attr('data-animinitial'),
        animdelay: parseInt(element.attr('data-animdelay'), 10),
        hide: false
    }, options);

    if (isNaN(settings.animdelay)) {
        settings.animdelay = 0;
    }
    setTimeout(function() {
        if (settings.animinitial !== undefined) {
            settings.animtype = settings.animinitial;
            element.removeAttr('data-animinitial');
        }
        element.removeClass('display-none').addClass('animated ' + settings.animtype).one(animationEnd, function() {
            $(this).removeClass('animated ' + settings.animtype);
            if (settings.hide) {
                $(this).addClass('display-none');
            }
        });
    }, settings.animdelay);

    return this;
};

// Funktion zur Prüfung auf korrekte JSON Struktur
function tryParseJSON(jsonString) {
    'use strict';
    try {
        var o = JSON.parse(jsonString);

        if (o && typeof o === "object" && o !== null) {
            return o;
        }
    } catch (ignore) {}

    return false;
}

// Cookie functions
function getCookie(cname) {
    'use strict';

    var name = cname + '=',
        ca = document.cookie.split(';'),
        i,
        c;

    for (i = 0; i < ca.length; i = i + 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function setCookie(cname, cvalue, exdays) {
    'use strict';

    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    var ovalue = getCookie(cname);
    if (ovalue !== null && ovalue !== '') {
        cvalue = ovalue + ',' + cvalue;
    }
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}

function checkCookie(cname, id) {
    'use strict';

    var cvalue = getCookie(cname);
    if (cvalue !== null && cvalue.indexOf(id) >= 0) {
        return cvalue;
    } else {
        return null;
    }
}



PNotify.prototype.options.styling = "bootstrap3";
var stack_bottomright = { "dir1": "up", "dir2": "left", "firstpos1": 25, "firstpos2": 25 };

function showNotify(title, text, type, delay) {
    var delay_ms = 3000;

    if (delay !== undefined){
        delay_ms = delay;
    }

    new PNotify({
        //title: title,
        text: text,
        type: type, // Type of the notice. "warning", "info", "success", or "error"
        animate: {
            animate: true,
            in_class: 'bounceInDown',
            out_class: 'bounceOutUp'
        },
        delay: delay_ms,
        addclass: "stack-bottomright font-normal",
        stack: stack_bottomright
    });
}

$(document).ready(function() {
    'use strict';

    /* Declare global Variables */
    var jRes, isMobile;

    /* Remove no-js class at html tag */
    $('html').removeClass('no-js');

    /* Initiate jRespond and assign breakpoints */
    jRes = jRespond([{
        label: 'smartphone',
        enter: 0,
        exit: 767
    }, {
        label: 'tablet',
        enter: 768,
        exit: 991
    }, {
        label: 'desktop',
        enter: 992,
        exit: 10000
    }]);

    isMobile = {
        android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        blackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        opera: function() {
            return navigator.userAgent.match(/Opera\ Mini/i);
        },
        windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function() {
            return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
        }
    };


    /* check screen resolution and fix banner height */
    function fixBannerHeight(owlhero) {
        var client_width = screen.width,
            client_height = screen.height;

        if (client_width > 460) {
            $('#hero-banner .banner-container').css('max-height', '');

            var banner_height = owlhero.outerHeight(),
                header_height = $('.header').outerHeight(),
                breadcrumb_height = $('#breadcrumb').outerHeight(),
                browser_top_area = 115, // Top area with address bar, tabs, menu and shortcuts height in px
                browser_status_bar = 25, // Bottom status bar height in px
                windows_task_bar = 40, // Windows task bar height in px
                max_banner_height = client_height - header_height - breadcrumb_height - browser_top_area - browser_status_bar - windows_task_bar,
                min_banner_height = 430;

            if (banner_height > max_banner_height) { // banner is to high, fix it
                max_banner_height = max_banner_height < min_banner_height ? min_banner_height : max_banner_height;
                $('#hero-banner .banner-container').css('max-height', max_banner_height);
            } else {
                $('#hero-banner .banner-container').css('max-height', '');
            }
        }
    }

    // Scrollto function
    function scrollToPosition(element) {
        'use strict';
        var breakpoint = jRes.getBreakpoint();
        var offset = 0;
        
        if (breakpoint === 'smartphone') {
            offset = 0;
        }
        $('html, body').stop().animate({
            scrollTop: $(element).offset().top - offset
        }, 1000);
        return false;
    }
 
    /* Initiate owl-carousel */
    if ($().owlCarousel) {
        (function() {
            //Sort random function
            function randomOwlElements(owlSelector){
                owlSelector.children().sort(function(){
                    return Math.round(Math.random()) - 0.5;
                }).each(function(){
                $(this).appendTo(owlSelector);
                });
            }

            if ($('#hero-banner').length) {
                var owlhero = $('#hero-banner'),
                    owlheroloop = true,
                    owlheroautoplay = true,
                    owlherodelay = 6000;

                if (owlhero.find('.banner-container').length > 1) {
                    if (owlhero.attr('data-loop') !== undefined) {
                        owlheroloop = owlhero.attr('data-loop');
                        if (owlheroloop === 'false') {
                            owlheroloop = false;
                        }
                    }
                    if (owlhero.attr('data-autoplay') !== undefined) {
                        owlheroautoplay = owlhero.attr('data-autoplay');
                        if (owlheroautoplay === 'false') {
                            owlheroautoplay = false;
                        }
                    }
                    if (owlhero.attr('data-delay') !== undefined) {
                        if (isNaN(parseInt(owlhero.attr('data-delay'), 10)) === false) {
                            owlherodelay = parseInt(owlhero.attr('data-delay'), 10);
                        }
                    }
                    owlhero.on('initialized.owl.carousel', function(event) {
                        fixBannerHeight(owlhero);
                    }).owlCarousel({
                        items: 1,
                        lazyLoad: true,
                        loop: owlheroloop,
                        mouseDrag: false,
                        nav: true,
                        navText: [],
                        autoplay: owlheroautoplay,
                        autoplayTimeout: owlherodelay,
                        autoplayHoverPause: true,
                        autoplaySpeed: 600,
                        navSpeed: 600,
                        dotsSpeed: 600
                    }).on('changed.owl.carousel resized.owl.carousel', function(event) {
                        var eleheight = owlhero.find('.banner-subtext').eq(event.item.index).outerHeight();
                        fixBannerHeight(owlhero);

                        //owlhero.find('.owl-nav').css('bottom', (eleheight + 75) / 2);
                    }).one('inview', '.owl-nav', function() {
                        //var eleheight = owlhero.find('.active .banner-subtext').eq(0).outerHeight();
                        //$(this).css('bottom', (eleheight + 75) / 2);
                    }).find('.banner-subtext').css('padding-bottom', '35px');
                } else {
                    //setTimeout(function() {
                        // fix for IE und FF with timeout
                        owlhero.show();
                    //}, 150);
                }
            }

            if ($('.owl-video-slider').length) {
                var owlvideo = $('.owl-video-slider'),
                    owlvideoloop = true,
                    owlvideodelay = 6000;

                if (owlvideo.find('.item-video').length) {
                    if (owlvideo.attr('data-loop') !== undefined) {
                        owlvideoloop = owlvideo.attr('data-loop');
                        if (owlvideoloop === 'false') {
                            owlvideoloop = false;
                        }
                    }
                    if (owlvideo.attr('data-delay') !== undefined) {
                        if (isNaN(parseInt(owlvideo.attr('data-delay'), 10)) === false) {
                            owlvideodelay = parseInt(owlvideo.attr('data-delay'), 10);
                        }
                    }

                    owlvideo.on('initialized.owl.carousel', function () {
                        $('.owl-video-slider .item-video').each(function () {
                            var poster = $(this).find('a.owl-video').data('poster');
                            if (typeof poster != 'undefined') {
                                $(this).find('.owl-video-tn').css({ 'background-image': 'url(' + poster + ')' });
                            }
                        });
                    }).owlCarousel({
                        items: 1,
                        merge: false,
                        loop: false,
                        margin: 10,
                        video: true,
                        nav: true,
                        navText: [],
                        dots: true,
                        dotsEach: true,
                        lazyLoad: false,
                        center: true,
                        videoWidth: false, // Default false; Type: Boolean/Number
                        videoHeight: false, // Default false; Type: Boolean/Number
                        responsive: {
                            480: {
                                items: 1,
                                videoWidth: false,
                                videoHeight: false
                            },
                            600: {
                                items: 1
                            }
                        }
                    });
                } else {
                    owlvideo.show();
                }
            }


            var owl = $('.owl-teaser'),
                owllenght = owl.length,
                owlloop = false,
                owlautoplay = false,
                owlmerge,
                owlnav = false,
                owlresponsive,
                owlrandom = false,
                owlmousedrag = true,
                i;

            if (owllenght) {
                for (i = 0; i < owllenght; i = i + 1) {
                    owlloop = true;
                    if ($(owl[i]).attr('data-loop') !== undefined) {
                        owlloop = $(owl[i]).attr('data-loop');
                        if (owlloop === 'true') {
                            owlloop = true;
                        }else{
                            owlloop = false;
                        }
                    }
                    if ($(owl[i]).attr('data-nav') !== undefined) {
                        owlnav = $(owl[i]).attr('data-nav');
                        if (owlnav === 'true') {
                            owlnav = true;
                        }else{
                            owlnav = false;
                        }
                    }
                    if ($(owl[i]).attr('data-autoplay') !== undefined) {
                        owlautoplay = $(owl[i]).attr('data-autoplay');
                        if (owlautoplay === 'true') {
                            owlautoplay = true;
                        }else{
                            owlautoplay = false;
                        }
                    }
                    if ($(owl[i]).attr('data-random') !== undefined) {
                        owlrandom = $(owl[i]).attr('data-random');
                        if (owlrandom === 'true') {
                            owlrandom = true;
                        }else{
                            owlrandom = false;
                        }
                    }
                    if ($(owl[i]).attr('data-mousedrag') !== undefined) {
                        owlmousedrag = $(owl[i]).attr('data-mousedrag');
                        if (owlmousedrag === 'false') {
                            owlmousedrag = false;
                        }else{
                            owlmousedrag = true;
                        }
                    }
                    owlresponsive = { '0': { items: 1 }, '480': { items: 2 }, '768': { items: 3 }, '992': { items: 4 } };
                    if ($(owl[i]).attr('data-owl') !== undefined) {
                        if (tryParseJSON($(owl[i]).attr('data-owl'))) {
                            owlresponsive = JSON.parse($(owl[i]).attr('data-owl'));
                        }
                    }
                    owlmerge = false;
                    if ($(owl[i]).find('[data-merge]').length) {
                        owlmerge = true;
                    }
                    $(owl[i]).owlCarousel({
                        onInitialize : function(element){
                            // Randomize elements order
                            if(owlrandom){
                                owl.children().sort(function(){
                                    return Math.round(Math.random()) - 0.5;
                                }).each(function(){
                                    $(this).appendTo(owl);
                                });
                            }
                        },
                        loop: owlloop,
                        mouseDrag: owlmousedrag,
                        merge: owlmerge,
                        autoplay: owlautoplay,
                        autoplayHoverPause: true,
                        slideBy: 1,
                        nav: owlnav,
                        navText: [],
                        responsive: owlresponsive
                    });
                }
                owl.on('resized.owl.carousel', function() {
                    var ele = $(this),
                        eleheight;

                    if (ele.hasClass('owl-content') === false) {
                        setTimeout(function() {
                            eleheight = ele.find('img').eq(0).outerHeight();
                            ele.find('.owl-nav').css('top', (eleheight - 57) / 2);
                        }, 500);
                    }
                    if (ele.hasClass('owl-info')) {
                        var elecon = ele.closest('.teaser-list');

                        elecon.find('.tab-pane.active').removeClass('active').end()
                            .find('.tab-activeicon').addClass('display-none');
                    }
                }).on('changed.owl.carousel', function() {
                    var ele = $(this);

                    if (ele.hasClass('owl-info')) {
                        var elecon = ele.closest('.teaser-list');

                        elecon.find('.tab-pane.active').removeClass('active').end()
                            .find('.tab-activeicon').addClass('display-none');
                    }
                }).one('inview', '.owl-nav', function() {
                    var ele = $(this),
                        eleheight;

                    if (ele.closest('.owl-content').length === 0) {
                        setTimeout(function() {
                            eleheight = ele.closest('.owl-teaser').find('img').eq(0).outerHeight();
                            ele.css('top', (eleheight - 57) / 2);
                        }, 500);
                    }
                });
            }

            var gallery = $('.owl-gallery'),
                gallerylenght = gallery.length,
                imgEle,
                imgElelength,
                imgSrc,
                img,
                x;

            function galleryLoaded(i, x) {
                $(imgEle[x]).removeAttr('data-gallerysrc').attr('src', imgSrc[x]);

                if (x === (imgElelength - 1)) {
                    var gallerycontainer = $(gallery[i]).closest('.gallery-container'),
                        gallerydots = true;

                    if (gallerycontainer.find('.owl-thumbnail').length) {
                        gallerydots = false;
                    }

                    setTimeout(function() {
                        gallerycontainer.find('.gallery-spinner').fadeTo('slow', 0);

                        $(gallery[i]).css('opacity', '0').owlCarousel({ // carousel function for image gallery
                            items: 1,
                            autoHeight: true,
                            nav: true,
                            navText: ['<i class="fa fa-angle-left font-xlarge color-white text-shadow" aria-hidden="true"></i>', '<i class="fa fa-angle-right font-xlarge color-white text-shadow" aria-hidden="true"></i>'],
                            navSpeed: 600,
                            dots: gallerydots,
                            dotsSpeed: 600
                        }).fadeTo('slow', 1);
                        gallerycontainer.removeAttr('style');

                        if (gallerydots === false) {
                            gallerycontainer.find('.owl-thumbnail').css('opacity', '0').owlCarousel({ // carousel function for thumbnail slider
                                autoWidth: true,
                                //center: true,
                                nav: false,
                                dots: false
                            }).on('click', '.owl-item', function() {
                                // On click of thumbnail items to trigger same main item
                                $(gallery[i]).trigger('to.owl.carousel', [$(this).index(), 500, true]);

                            }).on('changed.owl.carousel', function(e) {
                                // On change of thumbnail item to trigger main item
                                $(gallery[i]).trigger('to.owl.carousel', [e.item.index, 500, true]);
                            }).fadeTo('slow', 1);

                            $(gallery[i]).on('changed.owl.carousel', function(e) {
                                //On change of main item to trigger thumbnail item
                                gallerycontainer.find('.owl-thumbnail').trigger('to.owl.carousel', [e.item.index, 500, true]);
                            });
                        }
                    }, 600);
                }
            }

            function galleryInit(i) {
                $(gallery[i]).closest('.gallery-container').one('inview', function(event, isVisible) {
                    $(this).height(300).append('<i class="gallery-spinner fa fa-cog fa-spin fa-3x fa-fw font-xlarge center-abs-transform"></i>');

                    for (x = 0; x < imgElelength; x = x + 1) {
                        imgSrc[x] = $(imgEle[x]).attr('data-gallerysrc');
                        img[x] = new Image();
                        img[x].onload = galleryLoaded(i, x);
                        img[x].src = imgSrc[x];
                    }
                });
            }

            if (gallerylenght) {
                for (i = 0; i < gallerylenght; i = i + 1) {
                    imgEle = $(gallery[i]).closest('.gallery-container').find('img[data-gallerysrc]');
                    imgElelength = imgEle.length;
                    imgSrc = [];
                    img = [];

                    galleryInit(i);
                }
                gallery.on('changed.owl.carousel resized.owl.carousel', function(event) {
                    var ele = $(this),
                        eleheight = ele.find('img').eq(event.item.index).outerHeight();

                    ele.find('.owl-nav').css('top', (eleheight - ele.find('.owl-prev').outerHeight()) / 2);
                }).one('inview', '.owl-nav', function() {
                    var ele = $(this),
                        eleheight = ele.closest('.owl-gallery').find('img').eq(0).outerHeight();

                    ele.css('top', (eleheight - ele.find('.owl-prev').outerHeight()) / 2);
                });
            }
        }());
    }

    /* Lazyload for images with class 'img-lazyload' */
    function inviewLazyLoad(){
        $('img[data-src]').one('inview', function(event, isVisible) {
            if (!isVisible) {
                return;
            }
            var element = $(this),
                imgSrc = element.attr('data-src'),
                img = new Image();
            // define what happens once the image is loaded.
            img.onload = function() {
                element.removeAttr('data-src');
                if (element.hasClass('js-inview-anim')) {
                    element.css({ 'padding-bottom': '0', 'opacity': '0' }).attr('src', imgSrc).fadeTo(350, 1, function() {
                        element.css('opacity', '').removeAttr('style');
                    });
                } else {
                    element.attr('src', imgSrc).removeAttr('style');
                }
            };
            // The onload function will now trigger once it's loaded.
            img.src = imgSrc;
        });
    }
    inviewLazyLoad();


    /* Initiate animate on elements */
    $('body').on('inview', '.js-animated', function(event, isVisible) {
        if (!isVisible) {
            return;
        }
        var element = $(this),
            animtype = element.attr('data-anim'),
            animinitial = element.attr('data-animinitial'),
            animdelay = parseInt(element.attr('data-animdelay'), 10),
            animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        if (isNaN(animdelay)) {
            animdelay = 0;
        }
        setTimeout(function() {
            if (animtype === undefined) {
                element.removeClass('js-animated');
            }
            if (animinitial !== undefined) {
                animtype = animinitial;
                element.removeAttr('data-animinitial');
            }
            element.removeClass('opacity-zero').addClass('animated ' + animtype).one(animationEnd, function() {
                $(this).removeClass('animated ' + animtype);
            });
        }, animdelay);
    });

    /* Display or hide elements on mobile devices */
    if (isMobile.android()) {
        $('.hidden-mobileos').hide();
        $('.visible-android').show();
    } else if (isMobile.blackBerry()) {
        $('.hidden-mobileos').hide();
        $('.visible-blackberry').show();
    } else if (isMobile.windows()) {
        $('.hidden-mobileos').hide();
        $('.visible-windows').show();
    } else if (isMobile.iOS()) {
        $('.hidden-mobileos').hide();
        $('.visible-ios').show();
    }
    
    if (isMobile.any()) {  // is a mobile
        $('.visible-mobileos').show();
        // $('.visible-mobileos').show();
        // $('.visible-webos').hide();
    } else {  // not a mobile
        //$('.visible-mobileos').show();
        // $('.visible-webos').show();
        // $('.visible-mobileos').hide();
    }

    if($('.js-browser-extension-check').length){
        var browser_name = browser();

        switch(browser_name) {
            case 'Chrome':
                $('.js-browser-extension-check').removeClass('display-none');
                $('.js-browser-extension-chrome').removeClass('display-none');
                break;
            case 'Firefox':
                $('.js-browser-extension-check').removeClass('display-none');
                $('.js-browser-extension-firefox').removeClass('display-none');
                break;
            default:
                $('.js-browser-extension-check').addClass('display-none');
        }
    }


    $('.js-fancybox-contact').fancybox({
        padding: 0,
        margin: [20, 20, 20, 10],
        helpers: {
            overlay: {
                locked: true
            }
        }
    });

    $(".various").fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
    });
    
    /* Inititate Accordions */
    (function() {
        var i,
            elements = $('a.accordion-headline'),
            elementslength = elements.length;

        // Close all Accordions which haven't class 'active'
        for (i = 0; i < elementslength; i = i + 1) {
            if ($(elements[i]).hasClass('active') === false) {
                $(elements[i]).find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                    .next('div.accordion-txt').hide().removeClass('active');
            }
        }
        // Add click event to all Accordions
        $(document).on("click", "a.accordion-headline", function(e) {
            var element = $(this);
            var parent = element.closest('.accordion-container');

            if (element.hasClass('active')) {
                element.removeClass('active').find('.accordion-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                    .next('div.accordion-txt').slideUp('fast').removeClass('active');
            } else {
                // in single accordion only one accordion can be open at once
                if(parent.hasClass('is-single-accordion')){
                    parent.find('div.accordion-txt').slideUp('fast').removeClass('active');
                    parent.find('.accordion-headline').removeClass('active');
                }

                element.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                    .next('div.accordion-txt').slideDown('fast').addClass('active');
            }
            
            e.preventDefault();
            $(".tooltipstered.form-error").tooltipster("hide");
        });
    }());

    
    /* Initiate Tabs */
    // Tabs on Info-Slider
    if ($('.owl-info').length) {
        $('body').on('touchstart mouseenter click', '.owl-info a', function(e) {
            var tab = $(this),
                tabcon = tab.closest('.teaser-list'),
                tabactive = tabcon.find('.owl-item.active'),
                tabiconleft = ((100 / tabactive.length) * (tabactive.index(tab.closest('.owl-item')) + 1)) - ((100 / tabactive.length) / 2) - 1,
                reference = $(tab.attr('href')).find('a.btn'),
                referencetarget = reference.attr('target');

            tabcon.find('.tab-activeicon').removeClass('display-none').css('left', tabiconleft + '%');
            if (e.type === 'mouseenter') {
                reference.hide();
            } else if (e.type === 'click' && reference.length) {
                if (referencetarget === undefined) {
                    referencetarget = '_self';
                }
                window.open(reference.attr('href'), referencetarget);
            } else {
                reference.show();
            }
            tab.tab('show');
            e.preventDefault();
        });
    }
  

    /* Trigger ScrollTo if url hash value matches element or if anchor href id page anchor */
    (function() {
        var urlhash = location.hash.replace('#', ''),
            hashele,
            scrollele = '#' + urlhash,
            breakpoint = jRes.getBreakpoint();

        // Check if url hash matches with an Accordion and set class 'active' and scroll to it, remove class 'active' from all other Accordions
        if (urlhash !== '') {
            if ($('#' + urlhash).length) {
                hashele = $('#' + urlhash);
            } else if ($('[name="' + urlhash + '"]').length) {
                hashele = $('[name="' + urlhash + '"]');
                scrollele = '[name="' + urlhash + '"]';
            }
            if (hashele !== undefined) {
                if (hashele.hasClass('accordion-headline') && hashele.hasClass('active') === false) {
                    //$('a.accordion-headline').removeClass('active');
                    hashele.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                        .next('.accordion-txt').show();
                }
                if (hashele.hasClass('tab-pane')) {
                    if (breakpoint === 'smartphone') {
                        if ($('a.accordion-headline[href="#' + urlhash + '"]').hasClass('active') === false) {
                            $('a.accordion-headline[href="#' + urlhash + '"]').click();
                        }
                    } else {
                        scrollele = '#js-' + urlhash;
                        $(scrollele).click();
                    }
                    scrollele = $('a[href="#' + urlhash + '"]');
                }
                setTimeout(function() {
                    scrollToPosition(scrollele);
                }, 500);
            }
        }
    }());
    $('body').on('click', 'a[href^="#"]', function(e) {
        var element = $(this),
            elementhash = element.attr('href').replace('#', ''),
            hashelement,
            scrollelement = '#' + elementhash,
            breakpoint = jRes.getBreakpoint();

        if (element.attr('role') !== 'tab' && element.hasClass('accordion-headline') === false && elementhash.length > 1) {
            if ($('#' + elementhash).length) {
                hashelement = $('#' + elementhash);
            } else if ($('[name="' + elementhash + '"]').length) {
                hashelement = $('[name="' + elementhash + '"]');
                scrollelement = '[name="' + elementhash + '"]';
            }
            if (hashelement !== undefined) {
                e.preventDefault();
                if (hashelement.hasClass('accordion-headline') && hashelement.hasClass('active') === false) {
                    //$('a.accordion-headline').removeClass('active');
                    hashelement.addClass('active').find('.accordion-arrow').removeClass('fa-angle-down').addClass('fa-angle-up').end()
                        .next('.accordion-txt').show().addClass('active');
                }
                if (hashelement.hasClass('tab-pane')) {
                    if (breakpoint === 'smartphone') {
                        if ($('a.accordion-headline[href="#' + elementhash + '"]').hasClass('active') === false) {
                            $('a.accordion-headline[href="#' + elementhash + '"]').click();
                        }
                    } else {
                        scrollelement = '#js-' + elementhash;
                        $(scrollelement).click();
                    }
                }
                setTimeout(function () {
                    scrollToPosition(scrollelement);
                    element.blur();
                }, 500);
                
            }
        }
    });


    /* Initialize PageUp Button onscroll and set onclick function to animate scroll top */
    if ($('#pageup2').length) {
        (function() {
            var pageup = $('#pageup');

            $('body').on('click', '#pageup', function(e) {
                $('html, body').stop().animate({
                    scrollTop: 0
                }, 1000);
            });

            if ($('.message-container').length) {
                pageup.css('bottom', '50px');
            }
            if ($(window).scrollTop() > 300) {
                pageup.addClass('active');
            }
            $(window).on('scroll', function() {
                if ($(window).scrollTop() > 300) {
                    pageup.addClass('active');
                } else {
                    pageup.removeClass('active');
                }
            });
        }());
    }



    /* Trigger functions based on breakpoints */
    jRes.addFunc([{
        breakpoint: 'smartphone',
        enter: function() {
            // Hide Footer Linklist and bind onclick function
            $('#footer .sitemap-title').on('click', function() {
                var element = $(this),
                    elementlist = element.next('ul');

                if (elementlist.hasClass('active')) {
                    element.find('.sitemap-arrow').removeClass('fa-angle-up').addClass('fa-angle-down');
                    elementlist.removeClass('active').slideUp();
                } else {
                    element.find('.sitemap-arrow').removeClass('fa-angle-down').addClass('fa-angle-up');
                    elementlist.addClass('active').slideDown();
                }
            }).next('ul').slideUp();
        },
        exit: function() {
            // Show Footer Linklist and remove onclick function
            $('#footer .sitemap-title').off('click').find('.sitemap-arrow').removeClass('fa-angle-up').addClass('fa-angle-down').end()
                .next('ul').removeClass('active').removeAttr('style');
        }
    }]);


    /* Set same height for each element with attribute data-sameheight */
    function setSameheight(ele) {
        var breakpoint = jRes.getBreakpoint();
        var heighest = 0;

        if (breakpoint === 'smartphone') {
            $(ele).removeAttr('style');
        }else{
            if($(ele).hasClass('js-sameheight-in-row')){  // if class set, sameheight will calculated for items in each row!
                if($(ele).closest('.row').length && $(ele).closest('.row').find('[class^=col-]').length > 1){
                    var elements_in_a_row = 1;
                    var count_elem_cols = $(ele).closest('.row').find('[class^=col-]').length;
                    var container_width =  Math.floor($(ele).closest('.row')[0].getBoundingClientRect().width);  // FF liefert bei 33% Col-width 366.667, Chrome und IE 366.656, daher vorher abrunden
                    var $elem_col = $(ele).closest('div [class^=col-]');
                    var elem_col_width = Math.floor($elem_col[0].getBoundingClientRect().width);  // FF liefert bei 33% Col-width 366.667, Chrome und IE 366.656, daher vorher abrunden
    
                    elements_in_a_row = Math.floor(container_width / elem_col_width);
    
                    var last_elem_index_loop = 0;
                    $(ele).each(function (i) {
                        i++;
                        var $element = $(this);
        
                        $element.css("height", "auto");
                        if ($element.height() > heighest) {
                            heighest = $element.height();
                        }

                        if(i == count_elem_cols){
                            $(ele).slice(last_elem_index_loop, i).height(heighest);
                            return false;
                        }

                        if(i % elements_in_a_row == 0){
                            $(ele).slice(i-elements_in_a_row, i).height(heighest);
                            heighest = 0;
                            last_elem_index_loop = i;
                        }
                    });
                }
            }else{
                $(ele).each(function () {
                    var $element = $(this);
        
                    $element.css("height", "auto");
                    if ($element.height() > heighest) {
                        heighest = $element.height();
                    }
                });
                $(ele).height(heighest);
            }
        }
    }

    function resizeSameheight() {
        var sameheight = $("[data-sameheight]"),
            sameheightclass = [],
            i;

        for (i = 0; i < sameheight.length; i = i + 1) {
            sameheightclass.push($(sameheight[i]).attr("data-sameheight"));
        }
        sameheightclass = $.uniqueSort(sameheightclass);
        for (i = 0; i < sameheightclass.length; i = i + 1) {
            setSameheight(sameheightclass[i]);
        }
    }

    function checkSameHeightElems(){
        if ($("[data-sameheight]").length) { 
            (function () {
                var resizetimer;

                $(window).on("resize", function () {
                    clearTimeout(resizetimer);
                    resizetimer = setTimeout(resizeSameheight, 250);
                });

                //setTimeout(function() {
                    resizeSameheight();
                //}, 250);
            }());
        }
    }
    checkSameHeightElems();


    // on modal scroll, update tooltipster position
    $('.modal').on('scroll', function(){
        $(this).find('.tooltipstered').tooltipster('reposition');
    });

    /* Initiate tooltipster and assign to all existing tooltips */
    function initiateTooltipster(){
        //$(".tooltipstered").tooltipster('destroy');
        
        if ($().tooltipster) {
            // Trigger info
            if ($('.js-tooltip-forminfo:not(.tooltipstered)').length) {
                $('.js-tooltip-forminfo:not(.tooltipstered)').tooltipster({
                    functionInit: function (origin, content) {
                        var tooltipcontent = $(origin).parent().find('.js-tooltip-text').html();

                        if (tooltipcontent !== undefined && tooltipcontent !== '') {
                            return tooltipcontent;
                        }
                    },
                    functionReady: function (origin, content) {
                        if (typeof Updater != 'undefined') {
                            Updater.setCkEditor(content);
                        }
                    },
                    contentAsHTML: true,
                    interactive: true,
                    contentCloning: false,
                    trigger: 'click',
                    delay: 200,
                    multiple: true,
                    maxWidth: 380,
                    theme: 'tooltipster-black',
                    position: 'top',
                    speed: 200
                });
            }
            // Trigger info Tooltip on focus
            if ($('.js-tooltip-trigger:not(.tooltipstered)').length) {
                $('.js-tooltip-trigger:not(.tooltipstered)').each(function () {
                    var element = $(this);
                    element.on('focus', function () {
                        element.parent().find('.js-tooltip-forminfo').tooltipster('show');
                    }).on('blur', function () {
                        element.parent().find('.js-tooltip-forminfo').tooltipster('hide');
                    });
                });
            }

            $('.tooltip:not(.tooltipstered)').tooltipster({
                theme: 'tooltipster-default',
                contentAsHTML: true,
                animation: 'grow',
                delay: 200
            }); 
        
            $('body').on('mouseenter', '.tooltip:not(.tooltipstered)', function(){
                $(this).tooltipster({ 
                    theme: 'tooltipster-default',
                    contentAsHTML: true,
                    animation: 'grow',
                    delay: 200
                }).tooltipster('show');
            });
        

            $('.social-share .tooltip-black:not(.tooltipstered)').tooltipster({
                theme: 'tooltipster-black',
                contentAsHTML: true,
                animation: 'fade',
                position: 'left',
                delay: 200
            });


            $('.tooltip-black:not(.tooltipstered)').tooltipster({
                theme: 'tooltipster-black',
                contentAsHTML: true,
                animation: 'fade',
                delay: 200
            }); 
        
            $('body').on('mouseenter', '.tooltip-black:not(.tooltipstered)', function(){
                $(this).tooltipster({ 
                    theme: 'tooltipster-black',
                    contentAsHTML: true,
                    animation: 'fade',
                    delay: 200
                }).tooltipster('show');
            });

            /* Initiate tooltipster custom trigger class */
            $('.js-custom-trigger-tooltip:not(.tooltipstered)').tooltipster({
                functionBefore: function (origin, continueTooltip) {
                    var tooltip = $(origin);

                    continueTooltip();

                    if (tooltip.closest(".modal-content").length) {
                        $(".tooltipster-black").css("z-index", "8030");
                    }
                },
                theme: "tooltipster-black",
                animation: 'fade',
                animationDuration: 100,
                delay: 0,
                trigger: 'custom',
                distance: 6,
                interactive: true
            });
        }
    }
    initiateTooltipster();

    /* Function to show and hide tooltipster */
    function showHideTooltipster(btn, tooltip_text) {
        $(btn).tooltipster("content", tooltip_text).tooltipster("show");
        setTimeout(function () {
            $(btn).tooltipster("hide");
        }, 750);
    }

    /* Clipboard success error function */
    var clipboard = new Clipboard('.js-copy-clipboard');
    clipboard.on('success', function (e) {
        var tooltip_text = "In die Zwischenablage kopiert";
        showHideTooltipster(e.trigger, tooltip_text);
        e.clearSelection();
    });


    /* loading button on click */
    $('body').on('click', '.btn.btn-loading', function(e) {
        var btn = $(this);
        if ($().validate && $(".form-general").length) {
            if(btn.closest(form).valid()){  // show loading only, if closest formular is valid!
                btn.button('loading');
                // commented 18.11.2017
                // setTimeout(function() {
                //     btn.button('reset');
                // }, 2000);
            }
        }
    });

    // slider function
    if ($('#slider').length) {
        var $slider = $("#slider");
        var $output = $("#js-results-per-page");
        var $output_input = $("#js-results-per-page-input");

        // Update the current slider value (each time you drag the slider handle)
        $slider.on('input', function(){
            $output_input.val($(this).val());
            $output.text($(this).val());
        });
    }

	
	/* TOOLTIP FOR ALL SITES STARTS */
	$(".cust_tooltip").tooltip({
		// place tooltip on the right edge
		position: "center right",
		// a little tweaking of the position
		offset: [-2, 10],
		// use the built-in fadeIn/fadeOut effect
		effect: "fade",
		// custom opacity setting
		opacity: 0.7,
		// select an other class
		tipClass: 'input_tooltip'
	});
	/* TOOLTIP FOR ALL SITES ENDS */
	

	
	$('.mail_link').click(function(e){
		e.preventDefault();
		var mail_value = $(this).attr('data-mail');
		mailDecryptLink(mail_value);
	});
	

    $('.js-auto-post').change(function(){
        var trigger_btn = $(this).data('autoclick-input');  // have to be an id in data-attribute
        $('#' + trigger_btn).trigger('click'); 
    });

    $('.js-trigger-click-id').click(function(){
        var trigger_id = $(this).data('trigger-id');  // have to be an id in data-attribute
        $('#' + trigger_id).closest('form').trigger('submit');
        $('#' + trigger_id).trigger('click');
    });

    $('body').on('change', '.js-image-upload-preview', function(e) {
        if ($().validate && $(".form-general").length) {
            if($(this).valid()){
                if (this.files && this.files[0]) {
                    var reader = new FileReader();
                    var chosen_file = this.files[0];
                    var target_img = $(this).data('preview-element');
        
                    reader.onload = function(e) {
                        $(target_img).attr('src', e.target.result);
                    };
                    reader.readAsDataURL(chosen_file);
                }
            }
        }
    });


     /* Job bookmarken */
     $('.ajax-action').bind('click', function(e){
        e.preventDefault();
        var current_element = $(this);
        //var replace_html = '<span title="Job in Ihrer Merkliste"><i class="fa fa-star" aria-hidden="true"></i></span>';
        var replace_html = $(this).data('replace-html-on-success');
        var url = $(this).data('href');

        $.ajax({
            type: "GET",
            url: url,
            //data: formData,
            success: function(response) {
                var unpackArr = JSON.parse(response);
                var status = unpackArr.status;
                var message = unpackArr.message;

                if (status == 'success') {
                    //current_element.find('.fa-star-o').removeClass('fa-star-o').addClass('fa-star');
                    current_element.replaceWith(replace_html);
                    showNotify('Gratulation', message, 'success');

                } else if (status == 'error') {
                    showNotify('Fehler', message, 'error');
                } else if (status == 'warning') {
                    showNotify('Hinweis', message, 'warning');
                }

            },
            error: function(request, status, error) {

                // $('#modal-ignore-film-title #error-message').html(response_title_text + "\n" + formatErrorMessage(request, error));
                // $('#modal-ignore-film-title #error-message').fadeIn();
            }
        });
    });

    /* Job bookmarken:end */


    $('body').on('change input', '#geschenk-suche :input', function (e) {
        $(".tooltipstered.form-error").tooltipster("hide");
    });
    
    // when BS Tab shown
    $('body').on('hide.bs.tab', 'a[data-toggle="tab"]', function (e) {
        $(".tooltipstered.form-error").tooltipster("hide");
    });

    /* nav-tabs hash in url schreiben */
    $('body').on('click', '.nav-tabs.js-hash-tabs a', function (e) {
        e.preventDefault();
        $(this).tab('show');
      });
      
    // store the currently selected tab in the hash value
    $('body').on('shown.bs.tab', 'ul.nav-tabs.js-hash-tabs > li > a', function (e) {
        var id = $(e.target).attr("href").substr(1);
        var element_id = $(e.target).attr("id");
        if(history.pushState) {  // change hash, on if pushState available in browser
            history.pushState(null, null, '#' + id);
        }
    });
    /* nav-tabs hash in url schreiben:end */


    // validate fileupload field on change
    $('input[type="file"].validate-upload').change(function(){
        $(this).valid();
	});

    $('body').on('show.bs.modal', '.modal', function () {
        if($('#pageup').hasClass('active')){
            $('#pageup').removeClass('active');
        }
    });

    // when modal opened, focus on first input
    $('body').on('shown.bs.modal', '.modal', function () {
        if(!$(this).hasClass('dont-autofocus')){
            $('input:visible:enabled:first', this).focus();
        }

        // Wenn Geschenk Suche, dann Funktion ausführen
        if($(this).find('#geschenk-suche:visible').length){
            setTimeout(function() {  // etwas warten, bis der Content reingeladen wurde, um dann die Checks durchzuführen
                checkRelatedElementsGeschenksuche();
            }, 250);
        }
    });

    // This event is fired when the modal has loaded content using the remote option
    $('body').on('loaded.bs.modal', '.modal', function () {
        /*
        initiateTooltipster();
        validateAllForms();
        */
       validateAllForms($(this));
       initiateTooltipster();
    });


    // scroll to top function
    if ($('#pageup').length) {
        (function(){
            var pageup = $('#pageup');
            var lastScrollTop = 0;
            var delta = 250;  // px to scroll before show header

            $('body').on('click', '#pageup', function(e) {
                e.preventDefault();
                var elements = 'html, body';

                // if modal open, scroll top modal
                if ($('.modal').is(':visible')) {
                    elements = '.modal';
                }

                $(elements).stop().animate({
                    scrollTop: 0
                }, 1000, function(){
                    $('#pageup').blur();
                    $('#pageup').unbind('mouseenter mouseleave');
                });
            });

            function calculateIfShowPageup(fromTop){
                if(fromTop < 200){
                    pageup.removeClass('active');
                }else{
                    if (fromTop > lastScrollTop){
                        // downscroll code
                        pageup.removeClass('active');
                    } else {
                        if(Math.abs(lastScrollTop - fromTop) <= delta){
                            return;
                        }
                        // upscroll code
                        pageup.addClass('active');
                    }
                }

                lastScrollTop = fromTop;
            }

            $(window).scroll(function(event){
                var fromTop = $(window).scrollTop();
                calculateIfShowPageup(fromTop);
            });

            $('#addwish').scroll(function(event){
                var fromTop = $(this).scrollTop();
                calculateIfShowPageup(fromTop);
            });
        })();
    }

    // fix for scrolltop animations
    $('body,html').bind('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function(e){
        if ( e.which > 0 || e.type == "mousedown" || e.type == "mousewheel" || e.type == "touchmove"){
            $("html,body").stop();
        }
    });


    //plugin bootstrap minus and plus
    //http://jsfiddle.net/laelitenetwork/puJ6G/
    $('.btn-number').click(function (e) {
        e.preventDefault();

        var fieldName = $(this).attr('data-field');
        var type = $(this).attr('data-type');
        var input = $("input[name='" + fieldName + "']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if (type == 'minus') {
                if (currentVal > input.attr('min')) {
                    input.val(currentVal - 1).change();
                }
                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }
            } else if (type == 'plus') {
                if (currentVal < input.attr('max')) {
                    input.val(currentVal + 1).change();
                }
                if (parseInt(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }
    });
    $('.input-number').focusin(function () {
        $(this).data('oldValue', $(this).val());
    });
    $('.input-number').change(function () {
        var minValue = parseInt($(this).attr('min'));
        var maxValue = parseInt($(this).attr('max'));
        var valueCurrent = parseInt($(this).val());

        name = $(this).attr('name');
        if (valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled');
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if (valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled');
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }
    });
    $(".input-number").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });


    // when modal with google maps opened
    $("#google-maps-modal").on("shown.bs.modal", function () {
        initMap();
    });

    $('body').on('hide.bs.modal', '.modal', function (e) {
        $(this).find(".tooltipstered.form-error").tooltipster("hide");
    });

    $('body').on('hidden.bs.modal', '.modal', function (e) {
        $(this).removeData('bs.modal');
        // die Tooltipster werden nicht immer im hide.bs.modal versteckt! Daher hier nochmal!
        $(this).find(".tooltipstered.form-error").tooltipster("hide");
    });


    $('.collapse').on('shown.bs.collapse', function (e) {
        var $clickedBtn = $(e.target).data('bs.collapse').$trigger;

        if ($clickedBtn.hasClass('js-hide-on-collapse-shown')){
            $clickedBtn.hide();
        }

        if ($clickedBtn.hasClass('js-collapse-read-more')){
            $clickedBtn.closest('.read-more-container').addClass('more-opened');
        }
    });

    $('.collapse').on('hidden.bs.collapse', function (e) {
        var $clickedBtn = $(e.target).data('bs.collapse').$trigger;

        if ($clickedBtn.hasClass('js-collapse-read-more')){
            $clickedBtn.closest('.read-more-container').removeClass('more-opened');
        }
    });


    /* Cookie hint Datenschutz */
    function checkCookieRead(cookie_name) {
        var ckele = $('.js-cookie-hint');

        function changeTopMargin() {
            $('body, .header, .sidebar').css('margin-top', ckele.outerHeight());
        }

        ckele.show();
        $('body, .header, .sidebar').css('margin-top', ckele.outerHeight());
        $(window).on('resize', changeTopMargin);

        $('a.js-cookie-accept').click(function(e) {
            setCookie(cookie_name, 'true', 365);
            $(this).closest('.js-cookie-hint').slideUp();
            $('body, .header, .sidebar').css('margin-top', 0);
            $(window).off('resize', changeTopMargin);
            e.preventDefault();
        });
    }

    if (checkCookie('jlCookieRead', 'true') === null) {
        checkCookieRead('jlCookieRead');
    }
    /************************************************* General functions ENDS *************************************************/


    /************************************************* Jobleiter functions STARTS *************************************************/
    
    /* TOP JOB SECTORS FUNCTIONS STARTS */
	/*$("#top_job_sectors").load("/ajax/get_top_job_sectors", function(responseText, statusText, xhr){
		if(statusText == "success"){
			setTimeout(function(){$("#top_job_sectors").fadeIn();},50);
		}
		if(statusText == "error"){
			//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
		}
	});*/
    /* TOP JOB SECTORS FUNCTIONS ENDS */

    /* TOP JOB SECTORS POSITIONS STARTS */
	/*$("#top_job_positions").load("/ajax/get_top_job_positions", function(responseText, statusText, xhr){
		if(statusText == "success"){
			setTimeout(function(){$("#top_job_positions").fadeIn();},50);
		}
		if(statusText == "error"){
			//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
		}
	});*/
    /* TOP JOB SECTORS POSITIONS ENDS */

    /* TOP JOB SECTORS POSITIONS STARTS */
	/*$("#top_job_federal_states").load("/ajax/get_top_job_federal_states", function(responseText, statusText, xhr){
		if(statusText == "success"){
			setTimeout(function(){$("#top_job_federal_states").fadeIn();},50);
		}
		if(statusText == "error"){
			//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
		}
	});*/
    /* TOP JOB SECTORS POSITIONS ENDS */

    /* TOP JOB SECTORS POSITIONS STARTS */
	/*$("#top_job_employment_types").load("/ajax/get_top_job_employment_types", function(responseText, statusText, xhr){
		if(statusText == "success"){
			setTimeout(function(){$("#top_job_employment_types").fadeIn();},50);
		}
		if(statusText == "error"){
			//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
		}
	});*/
    /* TOP JOB SECTORS POSITIONS ENDS */

    /* TOP JOBS START PAGE STARTS */
	/*setTimeout(function(){
		$("#top_jobs_container").load("/jobs/ajax/get_top_jobs_right_box", function(responseText, statusText, xhr){
			if(statusText == "success"){
				setTimeout(function(){$("#top_jobs_container").fadeIn();},250);
			}
			if(statusText == "error"){
				//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
			}
	});
	}, 100); */
	/* TOP JOBS START PAGE ENDS */
    
    /* TOP JOB SECTORS FUNCTIONS STARTS */
	/*$("#top_job_sectors").load("/ajax/get_top_job_sectors", function(responseText, statusText, xhr){
		if(statusText == "success"){
			setTimeout(function(){$("#top_job_sectors").fadeIn();},50);
		}
		if(statusText == "error"){
			//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
		}
	});*/
    /* TOP JOB SECTORS FUNCTIONS ENDS */
    
    /* LOAD SIMILAR JOBS STARTS */
    if($('#js-load-similar-jobs').length){
        var job_id = $('#js-load-similar-jobs').data('job-id');

        $("#js-load-similar-jobs").load("/ajax/get_similar_jobs?jobid="+job_id, function(responseText, statusText, xhr){
            if(statusText == "success"){
                //resizeSameheight();
                checkSameHeightElems();
            }
        });
    }
	
    /* LOAD SIMILAR JOBS ENDS */

    /* TOP COMPANIES FUNCTIONS STARTS */
    var count_elements = $("#js-top-companies").find(".item").length;
    $("#js-top-companies").owlCarousel({
        loop: true,
        lazyLoad: true,
        rewind: false,
        //margin: 20,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 5000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        smartSpeed: 1250,
        responsive: {
            0: {
                items: 1,
                loop: (count_elements > 1 ? true : false)
            },
            320: {
                items: 2,
                slideBy: 2,
                loop: (count_elements > 2 ? true : false)
            },
            600: {
                items: 4,
                slideBy: 2,
                loop: (count_elements > 4 ? true : false)
            },
            1000: {
                items: 6,
                slideBy: 2,
                loop: (count_elements > 6 ? true : false)
            }
        }
    }).on('mouseenter', function (e) {
        $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
    }).on('mouseleave', function (e) {
        $(this).closest('.owl-carousel').trigger('play.owl.autoplay', [500]);
    });
	/* TOP COMPANIES FUNCTIONS ENDS */
	
	
	/* TOP JOBS SEARCH PAGE STARTS */
	setTimeout(function(){ 
		$("#right_box_top_jobs").load("/jobs/ajax/get_top_jobs_right_box", function(responseText, statusText, xhr){
			if(statusText == "success"){
				setTimeout(function(){$("#right_box_top_jobs").fadeIn();},250);
			}
			if(statusText == "error"){
				//alert("An error occurred: " + xhr.status + " - " + xhr.statusText);
			}
	    });
	}, 100); 
	/* TOP JOBS SEARCH PAGE ENDS */
	

	/* JOB SEARCH SITE STARTS */
	if(typeof jobfilter_set == 'undefined' || jobfilter_set == false){
		if($('#dv_search_for_job #search_text').val() == '' || $('#dv_search_for_job #search_text').val() == "Manager, Mechaniker etc."){
			$("#search_text").focus();
		}
	}
	/* JOB SEARCH SITE ENDS */

     $('.dropdown-menu .dropdown-user-data').click(function(e) {
        e.stopPropagation();
    });
    
	
	// 05.09.2017 - Überprüfe, ob Bewerbung ohne Dokumente abgesendet wird
	$('#form-apply-for-job #btn-send-application').click(function(event) {
        var file_amount_uploaded_files = 0,  // Anzahl Dokumente
            file_amount_candidate_files = 0,  // Anzahl docs vom profil
            file_amount_total = 0;  // Anzahl gesamt
        
        if($('#form-apply-for-job #file-amount').length){
            file_amount_uploaded_files = parseInt($('#form-apply-for-job #file-amount').text());
        }
        if($('#js-my-documents input[type="checkbox"]').length){
            file_amount_candidate_files = parseInt($('#js-my-documents input[type="checkbox"]:checked').length);  
        }
        file_amount_total = parseInt(file_amount_uploaded_files + file_amount_candidate_files);  

		if(file_amount_total < 1){
			event.preventDefault();
			if(confirm('Sind Sie sicher, dass Sie Ihre Bewerbung ohne Dokumente absenden möchten?') == true){
                //$('#form-apply-for-job').submit();  // geht nicht, btn name "send" wird dann nicht gepostet.
                $('#btn-send-application-hidden').trigger('click');
			} else {
                $(this).button('reset');
            }
		}
    });
    
    
    /* load federal states of country */
    function getFederalStates(elem){
        var $elem = elem;
        var country_id = $elem.val();
        var $federal_state_sel = $('#sel_federal_state');
        var posted_federal_state_id = $('#sel_federal_state').data('posted-federal-state-id');

        if(country_id) {
            $.ajax({
                url: "/ajax/get_federal_states_of_country",
                dataType: 'Json',
                data: {'country-id' : country_id},
                beforeSend: function() {
                    $federal_state_sel.html('<option value="">Lade Bundesländer...</option>');
                    $federal_state_sel.prop("disabled", true);
                },
                success: function(data) {
                    $federal_state_sel.empty();
                    $federal_state_sel.append('<option value="">Bitte wählen...</option>');
                    $.each(data, function(key, value) {
                        $federal_state_sel.append('<option value="'+ key  +'"' + (posted_federal_state_id !== undefined && key == posted_federal_state_id ? "selected" : "") +'>'+ value +'</option>');
                    });
                    $federal_state_sel.prop("disabled", false);
                }
            });
    
        }else{
            $federal_state_sel.empty();
            $federal_state_sel.append('<option value="">Bitte vorher Land wählen...</option>');
            $federal_state_sel.prop("disabled", true);
        }
    }

    $("#sel_country").change(function () {
        getFederalStates($(this));
    });
    
    $(function () {
        $("#sel_country").change();
    });
    /* load federal states of country:end */

    
    $("#redeem-voucher").click(function(e) {
        $('#voucher-code').prop('required', true);
        if($('#voucher-code').valid()){
            $('.membership').prop('required', false);
            $('#check_coupon').trigger('click');
        } else {
            $('.membership').prop('required', true);
            $('#voucher-code').prop('required', false);            
        }
    });


    $('.js-check-captcha').submit(function(e) {
        e.preventDefault();
        var $this = $(this);
        var recaptcha_website_key = $('#g-recaptcha-response').data('website-key');
        
        if($(this).closest(form).valid()){
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_website_key, {action: 'homepage'})
                    .then(function(token) {
                        $('#g-recaptcha-response').val(token);
                        setTimeout(function(){
                            $this.unbind('submit').submit(); // continue the submit unbind preventDefault
                        }, 200);
                });
            });
        }
    });


    // fire iframe resize when window is resized
    var windowResizeFunction = function (resizeFunction, iframe) {
        $(window).resize(function () {
            resizeFunction(iframe);
        });
    };
    
    $('iframe.js-iframe-auto-height').iframeAutoHeight({
        debug: false,
        heightOffset: 15,
        triggerFunctions: [
            windowResizeFunction
        ]
    });

    $('.js-controlls-price-box').on('change', function(e){
        var json_obj = $(this).data('json');
        var json_keys_length = Object.keys(json_obj).length;

        if(json_keys_length > 0){
            $('.js-controlled-price-box').fadeIn();
        }else{
            $('.js-controlled-price-box').fadeOut();
        }

        $.each(json_obj, function(index, element) {
            $(index).text(element);
        });
    }).each(function () {
        if ($(this).is(':checked')) {
            console.log("ja checked");
            console.log($(this).val());
            $(this).trigger("change");
        }
    });

    // scroll header fixed function
    /*
    (function(){
        var $header = $("header"),
        $clone = $header.before($header.clone().addClass("clone"));
        $('header.clone').find('.navbar-collapse').removeAttr('id');
        var delta = 150;  // px to scroll before show header

        var lastScrollTop = 0;
        $(window).scroll(function(event){
           //var st = $(this).scrollTop();
           var fromTop = $(window).scrollTop();

            if(fromTop < 200){
                $('body').removeClass('down');
                //$('header.clone').detach();
                // close all opened dropdowns
                $('header.clone .dropdown').removeClass('open');
            }else{
                if (fromTop > lastScrollTop){
                    // downscroll code
                    $('body').removeClass('down');
                } else {
                    if(Math.abs(lastScrollTop - fromTop) <= delta){
                        return;
                    }
                   // upscroll code
                   $('body').addClass('down');
                }
            }

            lastScrollTop = fromTop;
        });
    })();
    */

    $('#test_import').click(function (e) {
        $.ajax({
            type: "GET",
            url: "/ajax/import_test",
            success: function(response) {
                $('#test_import_response').html(response);
            },
            error: function(request, status, error) {

            }
        });
    });
    

    if (window.location.search.indexOf('print=1') > -1) {
        if($("#iframe_job_html").length){
            setTimeout(function(){ 
                window.frames.iframe_job_html.focus();
                window.frames.iframe_job_html.print();
            }, 500);
        }else{
            window.print();
        }
    }
    /************************************************* Jobleiter functions ENDS *************************************************/
});